module.exports = __webpack_public_path__ + "img/mute.58f2c68e.svg";